type TipoToast = "erro" | "sucesso" | "info";

import { extrairMensagemErroApi } from "./mensagemErroApi";

const CONTAINER_ID = "app-toast-container";
const TOAST_BOTTOM_OFFSET = "48px";

export function normalizarMensagemErro(texto: string): string {
  // O fluxo conhece a ação e a validação: não converter instruções em erros de cadastro.
  return String(texto || "").trim();
}

/** Usa a ação do formulário: preparar um rascunho para anexos não transforma cadastro em edição. */
export function mostrarToastCadastro(entidade: string, emEdicao: boolean) {
  mostrarToast(
    emEdicao ? `Edição de ${entidade} concluída.` : `Cadastro de ${entidade} concluído.`,
    "sucesso"
  );
}

function obterContainer(): HTMLDivElement | null {
  if (typeof document === "undefined") return null;

  const existente = document.getElementById(CONTAINER_ID);
  if (existente instanceof HTMLDivElement) return existente;

  const container = document.createElement("div");
  container.id = CONTAINER_ID;
  Object.assign(container.style, {
    position: "fixed",
    bottom: `calc(env(safe-area-inset-bottom, 0px) + ${TOAST_BOTTOM_OFFSET})`,
    right: "16px",
    zIndex: "2147483000",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "6px",
    width: "max-content",
    maxWidth: "min(360px, calc(100vw - 32px))",
    pointerEvents: "none",
  });
  document.body.appendChild(container);
  return container;
}

function cores(tipo: TipoToast) {
  if (tipo === "erro") {
    return {
      border: "color-mix(in srgb, var(--danger, #ef4444) 48%, transparent)",
      background: "color-mix(in srgb, var(--card, #222) 88%, var(--danger, #ef4444))",
      color: "var(--text, #fff)",
      accent: "var(--danger, #ef4444)",
    };
  }

  if (tipo === "sucesso") {
    return {
      border: "color-mix(in srgb, #22c55e 44%, transparent)",
      background: "color-mix(in srgb, var(--card, #222) 88%, #22c55e)",
      color: "var(--text, #fff)",
      accent: "#22c55e",
    };
  }

  return {
    border: "color-mix(in srgb, var(--accent-main, #4cc9d8) 42%, transparent)",
    background: "color-mix(in srgb, var(--card, #222) 88%, var(--accent-main, #4cc9d8))",
    color: "var(--text, #fff)",
    accent: "var(--accent-main, #4cc9d8)",
  };
}

export function mostrarToast(texto: string, tipo: TipoToast = "info") {
  const container = obterContainer();
  if (!container) return;

  const paleta = cores(tipo);
  const toast = document.createElement("div");
  toast.setAttribute("role", tipo === "erro" ? "alert" : "status");
  toast.setAttribute("aria-live", tipo === "erro" ? "assertive" : "polite");
  toast.textContent = texto;

  Object.assign(toast.style, {
    position: "relative",
    width: "fit-content",
    maxWidth: "100%",
    minHeight: "32px",
    padding: "7px 11px 7px 34px",
    border: `1px solid ${paleta.border}`,
    borderRadius: "9px",
    background: paleta.background,
    color: paleta.color,
    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.3)",
    fontFamily: "inherit",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "1.25",
    pointerEvents: "auto",
    opacity: "0",
    transform: "translateY(8px)",
    transition: "opacity 0.18s ease, transform 0.18s ease",
  });

  const marcador = document.createElement("span");
  marcador.textContent = tipo === "erro" ? "!" : tipo === "sucesso" ? "✓" : "i";
  Object.assign(marcador.style, {
    position: "absolute",
    left: "10px",
    top: "50%",
    width: "15px",
    height: "15px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: paleta.accent,
    color: "#fff",
    fontSize: "10px",
    fontWeight: "900",
    transform: "translateY(-50%)",
  });
  toast.prepend(marcador);

  container.appendChild(toast);
  window.requestAnimationFrame(() => {
    toast.style.opacity = "1";
    toast.style.transform = "translateY(0)";
  });

  window.setTimeout(() => {
    toast.style.opacity = "0";
    toast.style.transform = "translateY(8px)";
    window.setTimeout(() => toast.remove(), 220);
  }, 4200);
}

export function mostrarToastErro(erro: unknown, fallback = "Não foi possível concluir a operação no servidor.") {
  const mensagem = extrairMensagemErroApi(erro, fallback);
  mostrarToast(normalizarMensagemErro(mensagem), "erro");
}

export function mostrarToastPrimeiroErroValidacao(erros: Record<string, string>) {
  const mensagem = Object.values(erros).find((texto) => String(texto || "").trim() !== "");
  if (mensagem) mostrarToastErro(mensagem);
}
